import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DebugService {

  log(...messages: any[]) {
    if (environment.debug) {
      console.log(...messages);
    }
  }

  warn(...messages: any[]){
    if (environment.debug) {
      console.warn(...messages);
    }
  }

  error_log(...messages: any[]) {
    const origin = new Error().stack?.split("\n")[2].trim();
    console.error(`[Origen: ${origin}]`, ...messages);
  }
}
